import { render, staticRenderFns } from "./__arranged_survey_form.vue?vue&type=template&id=2b510296&"
import script from "./__arranged_survey_form.vue?vue&type=script&lang=js&"
export * from "./__arranged_survey_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports